export default __webpack_public_path__ + "static/media/char_head_prem_015.54de51aa.png";